//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import step from '@/components/Step'
import { dataMixins } from '@/mixins'
import { setCache } from '@/utils/storage'

export default {
    mixins: [dataMixins],
    data() {
        return {
            list: [],
            packageType: '',
            id: ''
        }
    },
  created() {
    this.getData()
  },
  methods: {
      buy(params, type) {
          // 设置session_storage存储选中的档次信息
          setCache('businessGrade_data', params)
          // packageType 转化为对应的业务场景类型 （25为学生 12为待机上台） 1.带机上台，2.集客上台,3.购机上台,4.旗舰机上台,5.缴费,6.储值卡增值,7.现有客户买手机,12.净手机购买,13.学生上台,14.简易上台,16.BR集客,17.極速開台,0.普通商品购买
          let _packageType = ({'25': '13', '12': '1'})[this.packageType]          
          console.log({type})
          this.$router.push({name: 'informationRegister', query: {...this.$route.query, type, packageType: _packageType, selected: params.selected, businessType: params.businessType, businessCode: params.businessCode, businessId: params.id, dataInfoId: this.id}})
      },
      isMore(discounts,months){
          let discountsList = discounts;
            let discountsItme = discountsList.find(item=>item.month=== String(months))|| {};
            const {discountsDataInfo} = discountsItme || {};
            let {discDataLv1List} = discountsDataInfo || {};
            return Array.isArray(discDataLv1List)&&discDataLv1List.length>3
      },
      isMoreData(data,months, more) {
            let discountsList = data|| [];
            let list = []

            let discountsItme = discountsList.find(item=>item.month=== String(months))|| {};
            const {discountsDataInfo} = discountsItme;
            if(!(typeof discountsDataInfo ==='object' && Reflect.has(discountsDataInfo,'discDataLv1List'))){
                return list
            }
            // let discounts= discountsDataInfo.discDataLv1List;
            let discDataLv1List = discountsDataInfo.discDataLv1List;
            if(Array.isArray(discDataLv1List)&&discDataLv1List.length>0){
                const sortList = [...discDataLv1List].sort((a,b)=>a.bundleSort - b.bundleSort);
                // list =sortList.length>3 ?sortList.slice(0,3): sortList;
                list=sortList
            }

          if(this.$device === 'pc') {
              if(more) return list
              else return list.slice(0,3)
          }else return list
      },
      getData () {
          this.$http('packageInfo/queryPcPackage', {...this.$route.query, marketSceneId: 852, registerTypeId: 1}).then(res=>{
              if(res.returnCode == '1000') {
                  try {
                      res.dataInfo.businessList.forEach((element, index) => {
                          
                          element.selected = element.contractList[0].months
                          element.more = false
                      });
                    let { businessList, packageType } = res.dataInfo                
                    this.list = businessList
                    this.packageType = packageType
                    this.id = res.dataInfo.id
                  }catch(e) { console.warn('请检查返回的数据') }
              }
          })
      }
  },
  components: {
      step
  }
};
